import { render, staticRenderFns } from "./itemUpdate.vue?vue&type=template&id=7d8c8f07&scoped=true"
import script from "./itemUpdate.vue?vue&type=script&lang=js"
export * from "./itemUpdate.vue?vue&type=script&lang=js"
import style0 from "./itemUpdate.vue?vue&type=style&index=0&id=7d8c8f07&prod&scoped=true&lang=css"
import style1 from "./itemUpdate.vue?vue&type=style&index=1&id=7d8c8f07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c8f07",
  null
  
)

export default component.exports